<template>
    <div style="border: 1px solid #ccc; width: 100%; height: 100%;">
        <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
        <Editor style="height: 500px; overflow-y: hidden;" v-model="html" :defaultConfig="editorConfig" :mode="mode"
            @onChange="onChange" @onCreated="onCreated" />
    </div>
</template>
<script>

import { Editor, Toolbar } from "@wangeditor/editor-for-vue";

export default ({

    components: { Editor, Toolbar },
    props: ['htmlData'],
    data() {
        return {
            editor: null,
            html: '',
            toolbarConfig: {},
            editorConfig: {
                placeholder: '请输入内容...',
                MENU_CONF: {
                    uploadImage: {
                        server: api + '/main/wangeditor/upload',
                        fieldName: 'file',
                        maxFileSize: 10 * 1024 * 1024, // 1M
                        headers: {
                            token: this.$store.state.userInfo.token
                        },
                        customInsert(res, insertFn) {
                            // res 即服务端的返回结果
                            if (res.code == 0) {
                                // 从 res 中找到 url alt href ，然后插入图片
                                insertFn(res.data.fullUrl, '', '')
                            }

                        },
                    }
                }
            },
            // mode: 'default', //默认模式
            mode: 'simple', //简洁模式

        }
    },
    methods: {
        onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        },
        onChange(editor) {
            // console.log("onChange", editor.getHtml()); // onChange 时获取编辑器最新内容

        },
        clear(){
            const editor = this.editor
            if (editor == null) return
            this.editor.clear();
        },
        giveHttp(val){
            this.html = val
        },
    },
    mounted() {
        // 模拟 ajax 请求，异步渲染编辑器
        setTimeout(() => {
            // console.log("html",this.html)
            this.html = this.htmlData
            // console.log("html",this.html)
        }, 500)
    },
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    }
})
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>


// WEBPACK FOOTER //
// src/components/fuwenben.vue